/* eslint-disable no-underscore-dangle */
export const checkHasSubscription = (items) => items.some((item) => item.properties._subscription_id);
export const getItemsId = (items) => items.map((item) => item.variant_id);
export const filterByItemId = (items) => (item) => !items.includes(Number(item.variantId));
